export default "__VITE_ASSET__D0pj2Stw__"